import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['button']

  connect() {
    document.addEventListener('scroll', () => {
      this.displayScrollToTopButton()
    })
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  displayScrollToTopButton() {
    if (window.scrollY > 5) {
      this.buttonTarget.classList.remove('hidden')
    } else {
      this.buttonTarget.classList.add('hidden')
    }
  }
}
